const getters = {
    suppliers: (state) => state.suppliers,
    supplierId: (state) => state.supplierId,
    loading: state => state.loading
};

export default getters;